import React, { useState } from "react";
import { Bell, MessageSquare, TrendingUp, Smartphone } from "lucide-react";
import RightRailMobilePreviewM2T from "./RightRailMobilePreviewM2T";

export default function RightRail({ showAppBar = true }) {
  const [view, setView] = useState("mobile");

  const alertsCount = 3;
  const trendingCount = 2;

  return (
    <aside
      className={`flex w-[200px] flex-col border-l border-slate-800 bg-[#0f172a] text-white transition-all duration-300`}
      style={{
        height: showAppBar
          ? "calc(100vh - 74px)" // TopBar + AppBar
          : "calc(100vh - 32px)",
      }}
    >
      {/* Sponsor area always visible */}
      <div className="border-b border-slate-800 bg-[#151b28] p-1">
        <div className="space-y-2">
          <div className="rounded-lg bg-slate-900 p-2 shadow-sm">
            <div className="text-[9px] font-semibold">
              Join live webinar March 5th,2026
            </div>
            <div className="text-[9px] text-slate-400">
              Learn advanced startegies for forex trading
            </div>
          </div>
          <div className="rounded-lg bg-slate-900 p-2 shadow-sm">
            <div className="text-[9px] font-semibold">
              AI market scanner-Trending
            </div>
            <div className="text-[9px] text-slate-400">
              Buy at 50% discount price, Hurry up.
            </div>
          </div>
        </div>
      </div>

      {/* Main content area */}
      <div className="flex-1 overflow-hidden">
        {view === "mobile" && <RightRailMobilePreviewM2T />}
        {view === "alerts" && (
          <div className="h-full space-y-2 overflow-y-auto p-3 text-xs">
            <div className="mb-2 text-sm font-bold">🔔 Market Alerts</div>
            <div className="rounded border border-yellow-600 bg-yellow-500/20 p-2 text-yellow-300">
              US CPI Report at 11:30 AM EST
            </div>
            <div className="rounded border border-blue-600 bg-blue-500/20 p-2 text-blue-300">
              Nvidia (NVDA) Earnings Call Today
            </div>
            <div className="rounded border border-red-600 bg-red-500/20 p-2 text-red-300">
              Gold volatility spiked 2.3%
            </div>
          </div>
        )}
        {view === "trending" && (
          <div className="h-full space-y-2 overflow-y-auto p-3 text-xs">
            <div className="mb-2 text-sm font-bold">🔥 Trending Now</div>
            <div className="rounded border border-green-700 bg-green-600/20 p-2 text-green-300">
              #GoldSurge
            </div>
            <div className="rounded border border-fuchsia-700 bg-fuchsia-600/20 p-2 text-fuchsia-300">
              #AIStocks
            </div>
          </div>
        )}
      </div>

      {/* Bottom Tab Bar */}
      <div className="flex border-t border-slate-700 bg-[#0d131f]">
        <button
          onClick={() => setView("mobile")}
          className={`flex flex-1 flex-col items-center py-2 text-[0.6rem] ${
            view === "mobile" ? "font-semibold text-sky-400" : "text-slate-400"
          }`}
        >
          <Smartphone className="h-3 w-3" />
          <span>Mobile</span>
        </button>
        <button
          onClick={() => setView("alerts")}
          className={`relative flex flex-1 flex-col items-center py-2 text-[0.6rem] ${
            view === "alerts" ? "font-semibold text-sky-400" : "text-slate-400"
          }`}
        >
          <Bell className="h-3 w-3" />
          {alertsCount > 0 && (
            <span className="absolute right-[32%] top-1 rounded-full bg-red-500 px-1 text-[8px] font-bold">
              {alertsCount}
            </span>
          )}
          <span>Alerts</span>
        </button>
        <button
          onClick={() => setView("trending")}
          className={`relative flex flex-1 flex-col items-center py-2 text-[0.6rem] ${
            view === "trending"
              ? "font-semibold text-sky-400"
              : "text-slate-400"
          }`}
        >
          <TrendingUp className="h-3 w-3" />
          {trendingCount > 0 && (
            <span className="absolute right-[32%] top-1 rounded-full bg-red-500 px-1 text-[8px] font-bold">
              {trendingCount}
            </span>
          )}
          <span>Trending</span>
        </button>
        {/* Chat Button */}
        <button
          className="flex flex-1 flex-col items-center py-2 text-[0.6rem] text-emerald-400 hover:text-emerald-300"
          title="Open Chat"
        >
          <MessageSquare className="h-3 w-3" />
          <span>Chat</span>
        </button>
      </div>
    </aside>
  );
}
